// Selectors
import { ApplicationState } from '../../store';


export const signupSelector = (state: ApplicationState) => state.signupState


